import React, { Fragment } from "react";
import Banner from '.././Elements/Banner';
import { withRouter, NavLink } from 'react-router-dom';

import { useClubStore } from '../store.js';

class AllClubsView extends React.Component {
    render() {
        
        const clubs = useClubStore.getState().selectedClubs;

        return (
            <Fragment>
                <Banner />
                <main> 
                    <div className="mainView-wrapper">
                        <div className="mainView">
                            <div className="fer-gridWrapper">
                                {clubs.map((club, index) => (
                                    <NavLink 
                                        key={index}
                                        className="fer-graphWrapper" 
                                        to={`/dashboard?selected_club=${club.url}`}
                                    >
                                        <div className="clubOverview-grid-item" >
                                            <img 
                                                className={"fer-graphWrapper-logo"} 
                                                style={{maxWidth: club.logo_max_width * 1.5 + 'rem'}}
                                                src={require(".././assets/clubLogos/" + club.logoFile)} 
                                            />
                                            <h3>{club.name}</h3>
                                        </div>   
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </main>
            </Fragment>
        );
    }
}

export default withRouter(AllClubsView);
